import { create } from 'zustand'

import type { ShowToastOptions, ToastItem } from './Toast.types'

const DEFAULT_TOAST_DURATION_MS = 5000

const timeoutIds = new Map<string, number>()

type ToastStore = {
    toasts: ToastItem[]
    showToast: (options: ShowToastOptions) => void
    removeToast: (id: string) => void
    clearToasts: () => void
}

export const useToastStore = create<ToastStore>((set, get) => ({
    toasts: [],

    clearToasts: () => {
        timeoutIds.forEach((timeoutId) => {
            window.clearTimeout(timeoutId)
        })
        timeoutIds.clear()
        set({ toasts: [] })
    },

    removeToast: (id) => {
        const timeoutId = timeoutIds.get(id)

        if (timeoutId) {
            window.clearTimeout(timeoutId)
            timeoutIds.delete(id)
        }

        set((state) => ({
            toasts: state.toasts.filter((toast) => toast.id !== id),
        }))
    },

    showToast: ({
        title,
        message,
        color,
        duration = DEFAULT_TOAST_DURATION_MS,
    }) => {
        const id = crypto.randomUUID()

        set((state) => ({
            toasts: [...state.toasts, { id, title, message, color }],
        }))

        const timeoutId = window.setTimeout(() => {
            get().removeToast(id)
        }, duration)

        timeoutIds.set(id, timeoutId)
    },
}))

export const showToast = (options: ShowToastOptions) => {
    useToastStore.getState().showToast(options)
}

export default useToastStore
